export default __webpack_public_path__ + "static/media/cart.b2a1474c.png";